module.exports = __webpack_public_path__ + "w.no2.10770583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/w.no2.jpg
// module id = GCQN
// module chunks = 0